import last from 'lodash/last';

export const getArrivalDate = (props) => {
  const lastBound = last(props?.bounds ?? []);
  const lastSegment = last(lastBound?.segments ?? []);
  return lastSegment?.arrivedAt ?? null;
};
